import { Tooltip } from "antd"
import { SaveState } from "./budgetCalculatorModel"
import { grey, blue, green, red } from '@ant-design/colors'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSave } from "@fortawesome/pro-solid-svg-icons"

type Props = {
  saveState: SaveState
}

const SaveStateColors = {
  UNSAVED: grey[1],
  SAVING: blue[3],
  SAVED: green[3],
  ERROR: red.primary
}

const SaveStateCopy = {
  UNSAVED: 'Save pending...',
  SAVING: 'Saving...',
  SAVED: 'Saved',
  ERROR: 'Save error'
}

const SaveIndicator = ({ saveState }: Props) => {
  return <Tooltip title={SaveStateCopy[saveState]} placement='left'>
    <div style={{ fontSize: '20px', minWidth: '20px', marginLeft: '10px' }}><FontAwesomeIcon icon={faSave} style={{color: SaveStateColors[saveState]}} /></div>
  </Tooltip>
}
export default SaveIndicator
